import Autocomplete from '../elements/autocomplete';
import SearchController from '../elements/main-search';
const initAutocomplete = () => {
  const minLength = 3;
  const autocompleteForms = document.querySelectorAll('.js-search-form');
  autocompleteForms.forEach($form => {
    new Autocomplete({
      selector: $form,
      minLength
    });
  });
  new SearchController(window.solrSearchAjaxType).init();
};
export default initAutocomplete;